export default function CTA() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://public.readdy.ai/ai/img_res/98508948dadeb78869481edcd0aa2c4f.jpg"
            alt="地域創生プロジェクト"
            className="w-full h-[400px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#2D7A3E]/90 to-[#2D7A3E]/70"></div>
          
          <div className="absolute inset-0 flex items-center justify-center px-8">
            <div className="text-center text-white max-w-3xl">
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                一緒に持続可能な<br />
                地域社会をつくりませんか
              </h2>
              <p className="text-lg mb-8 text-white/95 leading-relaxed">
                廃校活用プロジェクトに関するご相談、自治体との連携、<br />
                技術に関するお問い合わせなど、お気軽にご連絡ください。
              </p>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}